export const DataTypes: ConnectorDataTypes = {
  'adobe-experience-manager': [
    {
      label: 'Assets',
      value: 'file_assets',
    },
    {
      label: 'Pages',
      value: 'pages',
    },
  ],
}

type ConnectorDataTypes = Record<string, DataType[]>

export interface DataType {
  label: string
  value: string
}
